import React from "react";
import PropTypes from "prop-types";
import styles from "./PendingUsersItem.module.css";
import formatDate from "shared/@utils/formatDate";

/**
 * View component. Displays information about a user in the pending users list.
 */
export function PendingUsersItem({ userInfo }) {
  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItem}>{userInfo.name}</div>
      <div className={styles.gridItem}>{userInfo.iboNum}</div>
      <div className={styles.gridItem}>{userInfo.pin}</div>
      <div className={styles.gridItem}>
        {`${formatDate(userInfo.premierSince, "MM/DD/YYYY")}`}
      </div>
    </div>
  );
}

PendingUsersItem.propTypes = {
  /**
   * Object with the posts info.
   */
  userInfo: PropTypes.shape({
    name: PropTypes.string,
    iboNum: PropTypes.string,
    pin: PropTypes.string,
    premierSince: PropTypes.string,
  }),
};
